import axios from "axios";

const API_URL = process.env.REACT_APP_BERNABEU;
const API_URL_V2 = process.env.REACT_APP_BERNABEU_V2;

export function getMe() {
  return new Promise((resolve, reject) => {
    axios.get(API_URL_V2 + `me`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function updateMe(data) {
  return new Promise((resolve, reject) => {
    axios.put(API_URL + `me`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function updateProfile(data) {
  return new Promise((resolve, reject) => {
    axios.put(API_URL_V2 + `profile`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getBranchAvailableDays(branch, day, sport = null, couponId = null, fieldId = null) {
  return new Promise((resolve, reject) => {
    let params : any = {
      day: day,
      sport: sport
    };

    if (couponId) {
      params.coupon_id = couponId;
    }

    if (fieldId) {
      params.field_id = fieldId;
    }

    axios.get(API_URL + `branches/${branch}/available_days`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getBranchFields(branch) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/${branch}/fields`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postSchedules(field, data, version = 2) {
  return new Promise((resolve, reject) => {
    axios.post((version == 2 ? API_URL_V2 : API_URL) + `fields/${field}/schedules`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getSchedules(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `schedules`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function putPayment(paymentId, data) {
  return new Promise((resolve, reject) => {
    axios.put(API_URL + `payments/${paymentId}`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getBranchCoupons(branch, sellingType, sellingModality, date = null) {
  return new Promise((resolve, reject) => {
    let params: any = {
      selling_type: sellingType,
      selling_modality: sellingModality,
    }

    if (date) {
      params.date = date;
    }
    axios.get(API_URL + `branches/${branch}/coupons`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getCouponCode(branch, code, params) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/${branch}/coupon/${code}`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function cancelSchedule(schedule, params) {
  return new Promise((resolve, reject) => {
    axios.delete(API_URL + `schedules/${schedule}`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getCreditCards() {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `client_cards`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postCreditCards(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `client_cards`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function deleteCreditCard(creditCardId) {
  return new Promise((resolve, reject) => {
    axios.delete(API_URL + `client_cards/${creditCardId}`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getDayUses(params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `day_uses`, { params: params }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postDayUseCheckIn(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `day_uses/checkin`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getSignatures(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `signatures`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getSignaturePlans(branch, data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/${branch}/signature/plans`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getContracts(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `contracts`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function cancelContract(contract, params = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(API_URL + `contracts/${contract}`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getPackages(branch, data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/${branch}/packages`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getCredits(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `credits`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getCreditsGroup(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `credits/group`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getCreditPurchases(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `credit_purchases`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postCreditPurchases(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `credit_purchases`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postLead(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `lead`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}
export function postRequestSupport(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `help_center/request_support`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postSignatures(branch, data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `branches/${branch}/signatures`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function patchSignature(id, data) {
  return new Promise((resolve, reject) => {
    axios.patch(API_URL + `signatures/${id}`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getScheduleAvailablePaymentMethods(branch, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `payments/${branch}/schedule/available_methods`, {
      params: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getZipcode(zipcode) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `zipcode`, {
      params: {
        zipcode: zipcode
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getInvoice(id) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `invoices/${id}`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function patchPayOnlineInvoice(id, data) {
  return new Promise((resolve, reject) => {
    axios.patch(API_URL + `invoices/${id}`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getBranchLessons(branch, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/${branch}/lessons`, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getNextLessons(schedule) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `lessons/${schedule}`).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postLessonAbsence(schedule, data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `lessons/${schedule}/absences`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function postLessonSpot(schedule, data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `lessons/${schedule}/spots`, data).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}
